import { Modal } from "./Modal";
import { Reveal } from "./Reveal";

export class DialogListener {
    static INITIATORS = {
        modal: "[data-modal]",
        reveal: "[data-modal-reveal]"
    };

    private dialogInitiator: HTMLElement;

    constructor(dialogInitiator: HTMLElement) {
        this.dialogInitiator = dialogInitiator;
        this.initListener();
    }

    initListener() {
        this.dialogInitiator.addEventListener("click", () => {
            this.dialogInitiator.dataset.modal ? this.initModal() : this.initReveal();
        });
    }

    initModal() {
        const modal = new Modal(this.dialogInitiator.dataset.modal);
        modal.render();
    }

    initReveal() {
        const reveal = new Reveal(this.dialogInitiator.dataset.modalReveal, this.dialogInitiator.dataset.title);
        reveal.render();
    }
}

const modalInitiators = document.querySelectorAll<HTMLElement>(DialogListener.INITIATORS.modal);
if (modalInitiators) {
    modalInitiators.forEach((initiator) => {
        new DialogListener(initiator);
    });
}
const revealInitiators = document.querySelectorAll<HTMLElement>(DialogListener.INITIATORS.reveal);
if (revealInitiators) {
    revealInitiators.forEach((initiator) => {
        new DialogListener(initiator);
    });
}
